import { Injectable, inject } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable, tap } from 'rxjs';

import { Environment } from '@app/common/interfaces';

import { SessionService } from '../services';


@Injectable({
  providedIn: 'root',
})
export class EnvironmentData {

  private _api = inject(FsApi);
  private _sessionService = inject(SessionService);

  public create(data: Environment = { id: null }): Environment {
    data.address = data.address || {};

    return data;
  }

  public save(data, config: RequestConfig = {}): Observable<any> {
    if (data.id) {
      return this.put(data, config);
    }

    return this.post(data, config);
  }

  public get(environmentId, data: any = {}): Observable<any> {
    return this._api.get(`environments/${environmentId}`, data, { key: 'environment' });
  }

  public gets(data: any = {}, config: RequestConfig = {}): Observable<any> {
    return this._api.request('GET', 'environments', data, { key: 'environments', ...config });
  }

  public put(environment, config: RequestConfig = {}): Observable<any> {
    return this._api.put(`environments/${environment.id}`, environment, { key: 'environment', ...config });
  }

  public post(environment, config: RequestConfig = {}): Observable<any> {
    return this._api.post('environments', environment, { key: 'environment', ...config });
  }

  public delete(environment): Observable<any> {
    return this._api.delete(`environments/${environment.id}`, environment, { key: 'environment' });
  }

  public switch(environmentId: number): Observable<any> {
    return this._api.put(`environments/${environmentId}/switch`, null, { key: 'environment' })
      .pipe(
        tap((response) => {
          this._sessionService.environment(response);
        }),
      );
  }

  public image(environment, file): Observable<any> {
    return this._api.post(`environments/${environment.id}/image`, { file }, { key: 'environment' });
  }

  public pdfLogoPost(environmentId: number, file): Observable<any> {
    return this._api.post(`environments/${environmentId}/pdflogo`, { file }, { key: 'objectImage' });
  }

  public typesPut(environmentId: number, data: any): Observable<any> {
    return this._api.put(`environments/${environmentId}/types`, data);
  }

  public deleteAccounts(environmentId: number, data: any = {}, config: RequestConfig = {}): Observable<any> {
    return this._api.delete(`environments/${environmentId}/accounts/${data.id}`,
      data, { key: 'objectAccount', ...config });
  }

  public diseasesPost(environmentId: number, data: any = {}): Observable<any> {
    return this._api.post(`environments/${environmentId}/diseases`,
      data);
  }

  public diseasePut(environmentDisease): Observable<any> {
    return this._api.put(`environments/${environmentDisease.environmentId}/diseases/${environmentDisease.diseaseId}`,
      environmentDisease, { key: 'environmentDisease' });
  }

  public diseaseGet(environmentId, diseaseId): Observable<any> {
    return this._api.get(`environments/${environmentId}/diseases/${diseaseId}`, {}, { key: 'environmentDisease' });
  }

  public diseaseFoundationsGets(environmentId, diseaseId): Observable<any> {
    return this._api.get(`environments/${environmentId}/diseases/${diseaseId}/foundations`, {}, { key: 'foundations' });
  }

  public diseaseFundsGets(environmentId, diseaseId, query): Observable<any> {
    return this._api.get(`environments/${environmentId}/diseases/${diseaseId}/funds`, query, { key: 'funds' });
  }
}
